import { defineStore } from 'pinia';

import { useLocale } from '@/hooks';
import type { LoginResponse, User } from '@/models';
import { Committee } from '@/models';

export const useUserStore = defineStore('user', {
  state: () => ({
    user: null as User | null
  }),
  actions: {
    setUser(user: User) {
      this.user = { ...this.user, ...user };
      if (user.language) {
        const { setLocale } = useLocale();
        setLocale(user.language);
      }
    },
    resetUser() {
      this.user = null;
    },
    // Add set token action
    setJwtToken(jwtToken: string) {
      if (this.user) {
        this.user = { ...this.user, jwtToken: jwtToken };
      }
    },
    login({ user, jwt }: LoginResponse) {
      this.setUser(user);
      this.setJwtToken(jwt);
    },
    isUserSubscribedToFrenchSession() {
      return this.user?.committee === Committee.france;
    },
  },
  getters: {
    loggedIn: (state) => !!state.user,
    id: (state) => state.user?.id,
    jwtToken: (state) => state.user?.jwtToken,
    committee: (state) => state.user?.committee
  },
  persist: true
});
